import { css } from "@emotion/react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { useStorefrontSettingsState } from "../../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { AvailabilityCalendarPopupButton } from "../../ProductDetails/AvailabilityCalendarPopupButton";

// ListView - Availability
export type ProductBrowserListItemAvailabilityProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserListItemAvailability: React.FC<
	ProductBrowserListItemAvailabilityProps
> = (props) => {
	const translate = useTranslate();
	const product = props.product;

	const storefrontSettingsState = useStorefrontSettingsState();
	const showOwnedQty =
		storefrontSettingsState.get().settings?.ShowOwnedQty ?? false;
	const totalIn = product.Availability?.TotalIn ?? 0;
	const total = product.Availability?.Total ?? 0;
	let available = "";
	if (totalIn > 0) {
		available += totalIn;
		if (showOwnedQty) {
			available += ` ${translate("of")} ${total}`;
		}
		available += ` ${translate("Available")}`;
	} else {
		available = translate("Availability");
	}

	return (
		<>
			{product.Availability && (
				<div
					className="availability"
					css={css`
						text-align: center;
						display: flex;
						flex-direction: column;
						align-items: center;
						gap: 0.5rem;
					`}
				>
					<div className="pt-2">
						<AvailabilityCalendarPopupButton product={product}>
							<span>{available}</span>
						</AvailabilityCalendarPopupButton>
					</div>
				</div>
			)}
			{!product.Availability && (
				<div className="availability" css={css`text-align:center;`}>
					(no availability data)
				</div>
			)}
		</>
	);
};
